"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.interruption.hint': 'Puedes interrumpir al agente hablando',
    'conversation.interruption.active': 'Interrumpiendo agente...',
};
